import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const WarningContainer = styled.div `
  margin-bottom: 20px;
  padding: 12px 20px;
  background-color: ${Colors.GS300};
`;
export const WarningContent = styled.div `
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;
export const WarningIconWrapper = styled.div `
  height: 24px;
  width: 20px;
`;
export const WarningText = styled.div `
  font-size: 16px;
  line-height: 24px;
`;
